import React from 'react';

const projekt = {
	'projekt.avaleht.pealkiri': 'Meil on mega ägedad projektid käsil:',
	'projekt.leader.pealkiri': 'Leader projekt',
	'projekt.leader.kaart.kirjeldus': () => (
		<p>Päikeseelektrijaama paigaldamine Varbla Puhkeküla hoonetele</p>
	),
	'projekt.sadam.pealkiri': 'Varbla Puhkeküla sadama ehitus',
	'projekt.sadam.kaart.kirjeldus': <p>EstLat harbors</p>,
	'projekt.kook.pealkiri':
		'Varbla Puhkeküla sadamahoone köögi-ja baariseadmete soetamine',
	'projekt.kook.kaart.kirjeldus': (
		<p>
			Toetuse kaasabil soetatakse uude sadamahoonesse kaasaegsed köögi- ja
			baariseadmed
		</p>
	),
	'projekt.kook.blokk1': (
		<>
			<h2>VARBLA PUHKEKÜLA SADAMAHOONE KÖÖGI-JA BAARISEADMETE SOETAMINE</h2>
			<p>Toetuse summa: 11 296.85</p>
			<p>
				Projekt elluviimine aitab kaasa ettevõtluse arendamisele ja
				mitmekesistamisele maapiirkonnas ning tõstab ettevõtte jätkusuutlikkust.
			</p>
			<p>
				Sadamahoone uus köök ja baar võimaldab teenindada mereturiste, samuti
				ümberkaudseid puhkajaid, luua uusi tooteid ja teenuseid ning väärindada
				kohalikku toidukultuuri.
			</p>
		</>
	),
};

export default projekt;
